import SmoothScroll from 'smooth-scroll';

export default (() => {
    const scroll = new SmoothScroll('a[href*="#"]', {
        header: '.js-scroll-offset',
        offset: 85
    });
    const scrollOnPageLoad = window.location.hash;
    if (scrollOnPageLoad && document.querySelector(scrollOnPageLoad)) {
        window.setTimeout(() => {
            scroll.animateScroll(document.querySelector(scrollOnPageLoad));
        }, 2000);
    }
})();
